class DispatchNoteService {
    #dispatchQoreAxiosInstance;

    constructor(dispatchQoreAxiosInstance) {
        if (!dispatchQoreAxiosInstance) {
            throw new Error('Axios instance is required');
        }
        this.#dispatchQoreAxiosInstance = dispatchQoreAxiosInstance;
    }

    /**
     * Retrieves DispatchNotes from the Dispatch Qore API.
     * @param {number} dispatchId
     * 
     * @returns {Promise<{noteId: number, dispatchId: number, noteTypeId: number, content: string, dateCreated: Date, createdByName: string, createdByEmail: string}[]}>>}
     */
    fetchDispatchNotes(dispatchId) {
        return this.#dispatchQoreAxiosInstance.get(`/dispatch-notes/${dispatchId}`);
    }
}

export default DispatchNoteService;
